import Layout from "../views/layout/Layout";

export default {
    path: '/conv',
    component: Layout,
    hidden: true,
    redirect: '/conv/conv-rule',
    meta: {title: '积分管理', icon: 'el-icon-coin'},
    children: [{
        path: 'conv-rule',
        name: 'conv-rule',
        component: () => import('@/views/conv/conv-rule'),
        meta: {title: '积分规则', icon: 'product-cate'},
        auth: 'conv:conv-rule'
    }, {
        path: 'conv-record',
        name: 'conv-record',
        component: () => import('@/views/conv/conv-record'),
        meta: {title: '积分记录', icon: 'product-cate'},
        auth: 'conv:conv-record'
    }]
}



// WEBPACK FOOTER //
// ./src/router/conv.js